import { render, staticRenderFns } from "./UnitManagement.vue?vue&type=template&id=1a796fce"
import script from "./UnitManagement.vue?vue&type=script&lang=js"
export * from "./UnitManagement.vue?vue&type=script&lang=js"
import style0 from "./UnitManagement.vue?vue&type=style&index=0&id=1a796fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports